// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"45ad0522","450":"9d502370","453":"53ced07e","884":"46df080d"}[chunkId] + ".chunk.js";
};